import { motion } from "framer-motion";
import { Plus, Flame } from "lucide-react";
import { PRODUCTS } from "../../data/site";
import { useCart } from "../../context/CartContext";

const Card = ({ p, i }) => {
  const { addItem } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={`product-card-${p.id}`}
    >
      <div className="relative overflow-hidden rounded-md bg-[#F2EBE1] aspect-[4/5]">
        <img
          src={p.image}
          alt={p.english}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="flex items-center gap-1.5 bg-[#1E1A17]/80 backdrop-blur text-[#F9F6F0] text-[11px] tracking-wide px-2.5 py-1 rounded-full">
            <Flame className="h-3 w-3 text-[#E28721]" /> {p.spice}
          </span>
          {p.seasonal && (
            <span className="bg-[#E28721] text-[#1E1A17] text-[11px] font-semibold tracking-wide px-2.5 py-1 rounded-full" data-testid={`seasonal-badge-${p.id}`}>
              Seasonal
            </span>
          )}
        </div>
        <button
          data-testid={`add-to-cart-${p.id}`}
          aria-label={`Add ${p.english} to basket`}
          onClick={() => addItem(p)}
          className="absolute bottom-3 right-3 h-11 w-11 rounded-full bg-[#B83A14] hover:bg-[#942B0D] text-white flex items-center justify-center shadow-lg translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300"
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>

      <div className="pt-5">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="font-serif text-2xl text-[#1E1A17]">{p.name}</h3>
          <span className="font-sans text-lg text-[#B83A14] whitespace-nowrap" data-testid={`product-price-${p.id}`}>₹{p.price}<span className="text-sm text-[#B4A79A]">/kg</span></span>
        </div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#B4A79A] mt-1">{p.english}</p>
        <p className="text-[#3D352F] text-sm leading-relaxed mt-3">{p.description}</p>
        <p className="text-[11px] text-[#8a7d70] italic leading-relaxed mt-3 pt-3 border-t border-[#E8E3DA]" data-testid={`allergen-note-${p.id}`}>
          Made with mustard oil &amp; whole spices. Please inform us of any food allergies before placing your order.
        </p>
      </div>
    </motion.div>
  );
};

export const Products = () => (
  <section id="pickles" className="bg-[#F9F6F0] py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-2xl mb-14 md:mb-20">
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#B83A14] font-semibold mb-4">The Collection</p>
        <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight text-[#1E1A17] leading-none">
          Six jars. <span className="italic">No compromises.</span>
        </h2>
        <p className="text-[#3D352F] text-base md:text-lg mt-6 leading-relaxed">
          Each jar is cured for weeks and filled the day it's ready. Priced per kilogram and delivered fresh across Delhi NCR. Seasonal pickles are made only for a few weeks a year.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
        {PRODUCTS.map((p, i) => (
          <Card key={p.id} p={p} i={i} />
        ))}
      </div>
    </div>
  </section>
);
